<template>
  <div v-if="!error">
    <v-card
      :class="`mt-3 owner-docs-card ${!mobile ? 'mr-4' : ''}`"
      v-show="items.length > 0"
      v-for="(item, i) in items.filter(o => isFiltered(o))"
      :key="i"
    >
      <v-card-title :style="{ color: themeColor }" class="owner-docs-card__title" primary-title>
        {{ item.title }}
        <v-layout align-end justify-space-between column>
          <div class="owner-docs-card__date">{{ formatDate(item.lastModified) }}</div>
        </v-layout>
      </v-card-title>
      <v-card-text>{{ item.description }}</v-card-text>
      <v-card-actions>
        <slot name="previewButton" v-bind="{ item }">
          <v-btn
            v-if="item.attachment"
            :style="{ color: themeColor }"
            @click="$emit('previewFile', item)"
          >
            <i class="bexsicon-docs-sm" />
            {{ $t('pages.documents.showDocumentBtn') }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
    <div v-show="items.length === 0" class="empty-state">{{ emptyState }}</div>
  </div>
</template>

<script>
export default {
  name: 'owner-doc-list',
  props: {
    items: {
      type: Array,
      required: true
    },
    emptyState: {
      type: String,
      required: true
    },
    themeColor: {
      type: String,
      required: true
    },
    visualizedFilter: {
      type: Boolean,
      default: null
    },
    error: {
      type: Boolean
    }
  },
  methods: {
    isFiltered(item) {
      if (this.visualizedFilter == null) {
        return true;
      } else {
        return !!this.visualized[item._id] === this.visualizedFilter;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';
.owner-docs-card {
  margin-bottom: 1em;
  &__date {
    font-size: 0.7em;
    text-align: right;
    flex: 1;
    padding: 0 1em;
    color: var(--label-color);
  }

  &__title {
    font-size: 1.3em;
    padding-bottom: 0;
    @include breakpoint(mobile) {
      font-size: 1.05em;
    }
  }

  &:last-of-type {
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/document/OwnerDocList.vue